import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { dashPath } from "../lib/utils-trel";

/**
 * ProtectedRoute
 * - If not logged in → /login (preserves `from` so post-login we can return).
 * - If logged in but role doesn't match → redirect to user's OWN dashboard
 *   (NOT to `/`). This keeps refresh stable for every role: a customer
 *   refreshing /provider lands on /customer, never the marketing home.
 * - Admins are allowed through every role-protected route (for support / impersonation
 *   tooling). This is intentional and audited.
 */
export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen flex items-center justify-center text-[#064E3B]"
      >
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }

  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    // Send the user to THEIR own dashboard so refreshes never feel lost.
    return <Navigate to={dashPath(user.role)} replace />;
  }

  return children;
}
